import { useApiMutation } from "@babackapp/private-api-client/client/use-api-mutation";

/**
 * Super-admin lookup of an email's personal data, plaintext against vault.
 * A mutation rather than a query: the email travels in the body, out of URLs.
 */
export function usePiiLookup(shopId: string) {
  return useApiMutation("post", "/internal/pii-vault/shops/{shopId}/lookup", {
    notify: { success: false, error: true },
    mapVariables: (email: string) => ({
      params: { path: { shopId } },
      body: { email },
    }),
  });
}
